import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React, {memo} from 'react';
import {colors} from '@/styles/tokens';

const MUISpinner = (): any => {
    return (
        <Backdrop sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={true}>
            <CircularProgress size={50} disableShrink style={{color: colors.primary.main}} />
        </Backdrop>
    );
};

export default memo(MUISpinner);
